import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    OutlinedInput,
    Radio,
    RadioGroup
} from '@mui/material';
import { Close } from '@mui/icons-material';

function UpdateMoal({ updateType, setFieldValue, setUpdateType, values, setShowDelete, editParent }) {
    return (
        <Dialog open={updateType} fullWidth maxWidth="xs">
            <DialogTitle id="alert-dialog-title">
                {' '}
                {editParent === 'delete' ? 'Delete recurring event' : 'Edit recurring event'}
                <IconButton
                    onClick={() => {
                        setFieldValue('event_nature', '');
                        setUpdateType(false);
                    }}
                    sx={{ position: 'absolute', top: '10px', right: '10px' }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    // defaultValue="this"
                    value={values.event_nature}
                    onChange={(event) => {
                        console.log('event_nature', event.target.value);

                        setFieldValue('event_nature', event.target.value);
                    }}
                    name="radio-buttons-group"
                >
                    <FormControlLabel value="this-event" control={<Radio />} label="This event" />
                    <FormControlLabel value="upcoming-events" control={<Radio />} label="This and following events" />
                    <FormControlLabel value="all-events" control={<Radio />} label="All events" />
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setUpdateType(false);
                        setFieldValue('event_nature', '');
                    }}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        setUpdateType(false);
                        if (editParent === 'delete') {
                            setShowDelete(true);
                        }
                    }}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UpdateMoal;
